<template>
  <div>
    <div class="input-group input-list no-select" @mouseover="showInsertPos($event, -1)" @mouseup="dealInputUp($event)">
      <div v-for="(item, index) in field" 
          @mouseover="showInsertPos($event, index)" 
          :class="{
            'temp-input': item.temp, 
            'group-col-2': layout == 20, 
            'group-col-3': layout == 30,
            'group-col-4': layout == 40
          }"
          v-show="!item.hide">
        <span class="fl" v-if="!item.temp">
         <div class="drag-shank" size="small" type="danger" @mousedown="sortInputDown(item, index)" v-if="!item.temp">
           <i class="fa fa-arrows fz-24 c-blue"></i>
         </div>
        </span>
        <span class="group-40-title m-l-10 fl max-w-120 text-overflow" v-if="!item.temp">{{ inputTitle[item.field_id] }}</span>
        <div class="m-l-20 fl" v-if="!item.temp">
          <el-input 
            class="group-40-input h-40 w-100" 
            :disabled="true" 
            v-if="inputType[item.field_id] == TYPE_INPUTTEXT || inputType[item.field_id] == TYPE_PASSWORD"></el-input>
          <el-input 
            class="group-40-input h-50 w-100" 
            type="textarea" 
            :disabled="true" 
            v-if="inputType[item.field_id] == TYPE_TEXTAREA">
          </el-input>
          <el-radio 
            disabled 
            v-if="inputType[item.field_id] == TYPE_RADIO">
            选项
          </el-radio>
          <el-checkbox 
            disabled 
            v-if="inputType[item.field_id] == TYPE_CHECKBOX">
            选项
          </el-checkbox>
          <el-select 
            class="group-40-input w-100" 
            disabled 
            placeholder="" 
            v-if="inputType[item.field_id] == TYPE_SELECT || inputType[item.field_id] == TYPE_CASCADER">
          </el-select>
          <el-date-picker 
            class="group-40-input w-100" 
            disabled 
            type="date" 
            v-if="inputType[item.field_id] == TYPE_DATE || inputType[item.field_id] == TYPE_BOTH_DATE_TIME">
          </el-date-picker>
          <el-time-select 
            class="group-40-input w-100" 
            disabled 
            v-if="inputType[item.field_id] == TYPE_TIME">
          </el-time-select>
          <i class="fa fa-upload c-blue fz-24" v-if="inputType[item.field_id] == TYPE_FILE"></i>
          <i class="fa fa-wpforms c-blue fz-24" v-if="inputType[item.field_id] == TYPE_EDITOR"></i>
          <i class="fa fa-reply-all c-blue fz-24" v-if="inputType[item.field_id] == TYPE_FOREIGNKEY"></i>
          <i class="fa fa-th c-blue fz-24" v-if="inputType[item.field_id] == TYPE_SUBFORM"></i>
          <i class="fa fa-asterisk c-blue fz-24" v-if="inputType[item.field_id] == TYPE_MULTIRELATE"></i>
          <i class="fa fa-cogs c-blue fz-24" v-if="inputType[item.field_id] == TYPE_SUBRELATE"></i>
        </div>
        <span class="fr" v-show="!item.temp">
          <el-button size="small" type="danger" @click="deleteInput($event, item, index)">删除</el-button>
        </span>
        <span class="fr m-r-10" v-if="item.field_auth == INPUT_READONLY && !item.temp">只读</span>
        <span class="fr m-r-10" v-if="item.field_auth == INPUT_EDITABLE && !item.temp">可写</span>
        <span class="fr m-r-10" v-if="item.field_auth == INPUT_EXIST && !item.temp">不可见</span>
      </div>
      <!-- 排序标签 -->
      <div class="temp-sort" :style="dragInputPos" v-if="curField.type">
        <span class="fl">
          <div class="drag-shank" size="small" type="danger">
            <i class="fa fa-arrows fz-24 c-blue"></i>
          </div>
        </span>
        <span class="m-l-10 max-w-400 text-overflow-w-60">{{inputTitle[curField.field_id]}}</span>
      </div>
      <!-- 排序标签 -->
    </div>
  </div>
</template>

<style scope>
  .input-group {
    min-height: 60px;
  }
  .group-col-2 {
    display: inline-block;
    width: 42%;
  }
  .group-col-3 {
    padding-left: 10px !important;
    padding-right: 10px !important;
    display: inline-block;
    width: 31%;
  }
  .group-col-4 {
    padding-left: 10px !important;
    padding-right: 10px !important;
    display: inline-block;
    width: 23%;
  }
  .group-col-4 .group-40-title {
    max-width:  50px;
  }
  .group-col-4 .group-40-input {
    width: 40px!important;
  }
</style>

<script>
  import modelConfig from '../../../../config/modelConfig'
  import flowConfig from '../../../../config/flowConfig'
  export default {
    props: ['inputList', 'field', 'inputTitle', 'inputType', 'layout'],
    data() {
      return {
        curInput: {}, // 当前拖拽的控件信息
        curField: { // 当前拖拽排序的控件
          default: {}
        },
        dragInputPos: { // 拖拽的控件位置
          left: 0,
          top: 0
        },
        insertPos: null, // 插入控件位置的索引值
        inputFlag: { // 拖拽、排序控件的标识
          isDrag: false,
          isSort: false
        }
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        document.addEventListener('mouseup', () => {
          // 控件拖拽、控件排序取消
          this.inputFlag.isDrag = false
          this.inputFlag.isSort = false
          if (this.insertPos != null) {
            delete this.curField.hide
            this.field.splice(this.insertPos, 1)
            this.insertPos = null
          }
          this.curField = {
            default: {}
          }
          this.curInput = {
            default: {}
          }
        })
        document.addEventListener('mousemove', (event) => {
          this.dragInputMove(event)
        })
      },
      // 显示插入的位置（绑定在已添加控件上）
      showInsertPos(event, index) {
        if (!this.inputFlag.isDrag && !this.inputFlag.isSort) {
          return
        }
        event.stopPropagation()
        let tempInput = {
          temp: true,
          default: {}
        }
        if (this.insertPos != null) {
          this.field.splice(this.insertPos, 1)
        }
        this.insertPos = index != -1 ? index : this.field.length
        this.field.splice(this.insertPos, 0, tempInput)
      },
      // 拖拽控件（鼠标点下）
      addInputDown(event, item, index) {
        this.curInput = item
        this.inputFlag.isDrag = true
        this.dragInputPos = {
          left: event.pageX - 270 + 'px',
          top: event.pageY - 180 + 'px'
        }
      },
      // 排序控件（鼠标点下）
      sortInputDown(item, index) {
        this.curField = item
        item.hide = true
        this.inputFlag.isSort = true
        this.dragInputPos = {
          left: event.pageX - 120 + 'px',
          top: event.pageY - 180 + 'px'
        }
      },
      // 拖拽、排序控件（鼠标移动）
      dragInputMove(event) {
        if (!this.inputFlag.isDrag && !this.inputFlag.isSort) {
          return
        }
        let left = ''
        let top = ''
        if (this.inputFlag.isDrag) {
          left = event.pageX - 270 + 'px'
        } else if (this.inputFlag.isSort) {
          left = event.pageX - 120 + 'px'
        }
        top = event.pageY - 180 + 'px'
        this.dragInputPos = {
          left: left,
          top: top
        }
      },
      // 拖拽、排序控件（鼠标弹起）
      dealInputUp(event) {
        if (!this.inputFlag.isDrag && !this.inputFlag.isSort) {
          return
        }
        if (this.inputFlag.isDrag) {
          // 拖拽添加
          this.addInputUp()
        } else if (this.inputFlag.isSort) {
          // 拖拽排序
          this.sortInputUp()
        }
        this.insertPos = null
      },
      // 添加控件鼠标弹起
      addInputUp() {
        let newField = {
          field_id: this.curInput.default.field_id,
          type: 10
        }
        this.field.splice(this.insertPos, 1, newField)
        this.curInput = {
          default: {}
        }
        this.inputFlag.isDrag = false
      },
      // 删除控件
      deleteInput($event, item, index) {
        let inputIndex = _.findIndex(this.inputList, (res) => {
          return res.default.field_id == item.field_id
        })
        // this.inputList[inputIndex].selected = false
        this.field.splice(index, 1)
      },
      // 排序控件鼠标弹起
      sortInputUp() {
        if (this.insertPos != null) {
          delete this.curField.hide
          let sourceIndex = _.indexOf(this.field, this.curField)
          this.field.splice(this.insertPos, 1, this.curField)
          this.field.splice(sourceIndex, 1)
        }
        this.curField = {
          default: {}
        }
        this.inputFlag.isSort = false
      }
    },
    mixins: [modelConfig, flowConfig]
  }
</script>


// WEBPACK FOOTER //
// inputGroup.vue?1831a1a0